import React from 'react';
import PropTypes from 'prop-types';

import '../sass/Loader.sass';

const Loader = ({ colour }) => {
  return (
    <div className="spinner" style={{ backgroundColor: colour }}></div>
  );
};

Loader.propTypes = {
  colour: PropTypes.string,
};

export default Loader;